// TEMPORARY LOGIC, LORAWAN STATION INNER ID STARTED FROM 100000
export const isLorawan = (id: string | number) => Number(id) >= 100000;